import React, { useEffect, useState } from "react";
import { showError, showSuccess } from "../../../utils/toastUtils";
import mpAPI from "../../../api/admin/mpApi";

function ChangePassword() {
  const [isLoading, setIsLoading] = useState(false);
  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");

  const [errors, setErrors] = useState({});

  const validate = () => {
    const newErrors = {};

    if (!currentPassword) {
      newErrors.currentPassword = "Current password is required.";
    } else if (currentPassword.length < 6) {
      newErrors.currentPassword =
        "New password must be at least 6 characters long.";
    }

    if (!newPassword) {
      newErrors.newPassword = "New password is required.";
    } else if (newPassword.length < 6) {
      newErrors.newPassword =
        "New password must be at least 6 characters long.";
    }

    if (!confirmPassword) {
      newErrors.confirmPassword = "Confirm password is required.";
    } else if (confirmPassword.length < 6) {
      newErrors.confirmPassword =
        "Confirm password must be at least 6 characters long.";
    }

    if (newPassword && confirmPassword && newPassword !== confirmPassword) {
      newErrors.submitError = "New password and confirm password do not match.";
    }

    if (currentPassword && newPassword && currentPassword === newPassword) {
      newErrors.submitError =
        "Current Password & New Password must not be same";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    setIsLoading(true);
    e.preventDefault();

    if (!validate()) {
      setIsLoading(false);
      return;
    }

    const payload = {
      current_password: currentPassword,
      new_password: newPassword,
      confirm_password: confirmPassword,
    };

    try {
      const res = await mpAPI.updatePassword(payload);
      if (res.code === 200) {
        showSuccess(res.message);

        setNewPassword("");
        setConfirmPassword("");
        setCurrentPassword("");
      } else {
        showError(res.message);
      }

      setIsLoading(false);
    } catch (err) {
      setIsLoading(false);
      showError(err.response?.data?.message || "Something went wrong");
    }
  };

  return (
    <>
      <div className="page-wrapper">
        <div className="content">
          <div className="page-header">
            <div className="page-title">
              <h4>Change Your Password</h4>
              <h6>
                Keep your account secure by updating your password regularly.
              </h6>
            </div>
          </div>
          {/* /product list */}
          <div className="row">
            <div className="col-md-6">
              <div className="card">
                <div className="card-header">
                  <h4>Update Your Password</h4>
                </div>
                <div className="card-body profile-body">
                  <form method="post" onSubmit={handleSubmit}>
                    <div className="row">
                      <div className="col-lg-12 col-sm-12">
                        <div className="mb-3">
                          <label className="form-label">
                            Current Password{" "}
                            <span className="text-danger">*</span>
                          </label>
                          <input
                            type="password"
                            className="form-control"
                            placeholder="Enter Current Password"
                            autoComplete="false"
                            value={currentPassword}
                            onChange={(e) => setCurrentPassword(e.target.value)}
                          />
                          {errors.currentPassword && (
                            <span className="errors text-danger">
                              {errors.currentPassword}
                            </span>
                          )}
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-lg-12 col-sm-12">
                        <div className="mb-3">
                          <label className="form-label">
                            New Password <span className="text-danger">*</span>
                          </label>
                          <input
                            type="password"
                            className="form-control"
                            autoComplete="false"
                            placeholder="Enter New Password"
                            value={newPassword}
                            onChange={(e) => setNewPassword(e.target.value)}
                          />
                          {errors.newPassword && (
                            <span className="errors text-danger">
                              {errors.newPassword}
                            </span>
                          )}
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-lg-12 col-sm-12">
                        <div className="mb-3">
                          <label className="form-label">
                            Confirm Password{" "}
                            <span className="text-danger">*</span>
                          </label>
                          <input
                            type="password"
                            className="form-control"
                            autoComplete="false"
                            placeholder="Enter Confirm Password"
                            value={confirmPassword}
                            onChange={(e) => setConfirmPassword(e.target.value)}
                          />
                          {errors.confirmPassword && (
                            <span className="errors text-danger">
                              {errors.confirmPassword}
                            </span>
                          )}
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-12">
                        {!isLoading && (
                          <button
                            type="submit"
                            id="submitBtn"
                            className="btn btn-primary shadow-none"
                          >
                            Update Password
                          </button>
                        )}
                      </div>
                      {errors.submitError && (
                        <span className="errors text-danger">
                          {errors.submitError}
                        </span>
                      )}
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default ChangePassword;
